export const userProfile = {
  username: "Όνομα Χρήστη",
  myProfile: "Το Προφίλ μου",
  myCompany: "Η Εταιρεία μου",
  detailedDescription: "Λεπτομερής Περιγραφή",
  myAccount: "Ο Λογαριασμός μου",
  uploadPhoto: "Ανέβασμα Φωτογραφίας",
  deleteProfile: "Διαγραφή Προφίλ;",
  areYouSureDeleteProfile:
    "Είστε σίγουροι ότι θέλετε να διαγράψετε το προφίλ σας; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί. Όλα τα δεδομένα σας θα διαγραφούν και δεν θα μπορείτε να τα ανακτήσετε.",
  profileDeletedSuccessfully: "Το προφίλ διαγράφηκε με επιτυχία",
  errorDeletingProfile:
    "Σφάλμα κατά τη διαγραφή του προφίλ. Παρακαλώ δοκιμάστε ξανά.",
  contactInfo: "Στοιχεία Επικοινωνίας",
  personalInfo: "Προσωπικά Στοιχεία",
  mobilePhone: "Κινητό Τηλέφωνο",
  assignedRoles: "Ανατεθειμένοι ρόλοι",
  telephone: "Τηλέφωνο",
  marketplacePreferences: "Προτιμήσεις αγοράς",
  personalDetailsFromSignIn:
    "Αυτά τα στοιχεία προέρχονται από το προφίλ σύνδεσής σας.",
  preferencesDescription:
    "Η γλώσσα, το νόμισμα και το θέμα αποθηκεύονται για τον λογαριασμό σας στην αγορά.",
  notProvided: "Δεν παρέχεται",
  notSet: "Δεν έχει οριστεί",
  theme: "Θέμα",
  profileManagedByKeycloak:
    "Η γλώσσα, το νόμισμα και το θέμα αποθηκεύονται για τον λογαριασμό σας στην αγορά. Τα προσωπικά στοιχεία παραπάνω προέρχονται από το προφίλ σύνδεσής σας.",
  preferencesViewOnly: "Μόνο προβολή — επεξεργασία για αλλαγή",
  preferencesSaveHint:
    "Αποθηκεύστε για να κρατήσετε τις αλλαγές στις προτιμήσεις της αγοράς.",
};
